import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemTitle,
  ItemTitleText,
  ItemTrigger,
} from 'designSystem/components/Item'
import { ArrowRight } from 'lucide-react'
import React from 'react'

import { type JumpToLinkCardItem } from './JumpToLinkCards'

export const LinkItem: React.FC<JumpToLinkCardItem> = ({
  title,
  description,
  onSelect,
  ariaLabel,
  disabled = false,
}) => {
  const handleClick = () => {
    if (disabled) return
    onSelect()
  }

  return (
    <Item variant='surface' size='md' disabled={disabled}>
      <ItemTrigger
        type='button'
        aria-label={ariaLabel ?? title}
        disabled={disabled}
        onClick={handleClick}>
        <ItemContent variant='document'>
          <ItemTitle variant='document'>
            <ItemTitleText>{title}</ItemTitleText>
          </ItemTitle>
          <ItemDescription variant='document'>{description}</ItemDescription>
        </ItemContent>
        <ItemActions variant='trailing' aria-hidden='true'>
          <ArrowRight size={16} />
        </ItemActions>
      </ItemTrigger>
    </Item>
  )
}
